import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Icon } from '../Icon';
import styles from './SubscriptionCardV9.css';

const cx = classnames.bind(styles);

function getDiscountPercent({ price, trial }) {
    if (!trial) return 0;

    const oldValue = Number.parseFloat(price.slice(1));
    const newValue = Number.parseFloat(trial.price.slice(1));

    return Math.round((1 - newValue / oldValue) * 100);
}

function getSubtitle(subscriptionData, withDiscount) {
    const weeks = subscriptionData.billingPeriod?.value;

    if (subscriptionData.trial) {
        return `${subscriptionData.trial.price} now, then auto-renews at ${subscriptionData.price} every ${weeks} weeks`;
    }

    return withDiscount
        ? `then ${subscriptionData.price} every ${weeks} weeks`
        : `${subscriptionData.price} auto-renews every ${weeks} weeks`;
}

function SubscriptionCardV9({ subscriptionData, selectedSubscriptionData, selectSubscription, isExpired }) {
    const isActive = subscriptionData.plan === selectedSubscriptionData.plan;
    const discountPercent = subscriptionData.displayDiscountPercent ?? getDiscountPercent(subscriptionData);
    const oldPrice = subscriptionData.displayOldPrice ?? subscriptionData.price;
    const isDiscountShown = !isExpired && discountPercent > 0;

    return (
        <label className={cx('root', { popular: subscriptionData.isPopular, active: isActive })}>
            <input
                type='radio'
                name='subscription-plan'
                value={subscriptionData.plan}
                checked={isActive}
                onChange={() => selectSubscription(subscriptionData)}
                className={styles.input}
            />
            {subscriptionData.isPopular && (
                <div className={styles.popularBanner}>
                    <Icon name='starFilled' className={styles.starIcon} />
                    Most popular
                </div>
            )}
            <div className={styles.content}>
                <div className={styles.left}>
                    <span className={styles.radio}>
                        <span className={styles.radioDot} />
                    </span>
                    <div className={styles.planInfo}>
                        <p className={styles.name}>{subscriptionData.name}</p>
                        <p className={styles.subtitle}>
                            {getSubtitle(subscriptionData, isDiscountShown)}
                        </p>
                    </div>
                </div>
                <div className={cx('right', { withReservedHeight: !isExpired })}>
                    {isDiscountShown && <span className={styles.originalPrice}>{oldPrice}</span>}
                    <span className={styles.price}>{subscriptionData.trial?.price ?? subscriptionData.price}</span>
                    {isDiscountShown && (
                        <span className={styles.discountBadge}>{discountPercent}% OFF</span>
                    )}
                </div>
            </div>
        </label>
    );
}

SubscriptionCardV9.propTypes = {
    subscriptionData: PropTypes.object.isRequired,
    selectedSubscriptionData: PropTypes.object.isRequired,
    selectSubscription: PropTypes.func.isRequired,
    isExpired: PropTypes.bool
};

SubscriptionCardV9.defaultProps = {
    isExpired: false
};

export {
    SubscriptionCardV9
};
